import { render, staticRenderFns } from "./six_sheet_index.vue?vue&type=template&id=32d22249"
import script from "./six_sheet_index.vue?vue&type=script&lang=js"
export * from "./six_sheet_index.vue?vue&type=script&lang=js"
import style0 from "./six_sheet_index.vue?vue&type=style&index=0&id=32d22249&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports